/**
 * LogoPath interface
 */

import { computed } from 'vue'

import { configService } from '@/common/utils/clientConfig'

import defaultLogo from '@/img/head-logo.png'
import rknLogo from '@/img/rkn-logo.svg'
import metroLogo from '@/img/spb-head-logo.svg'
import rfcLogo from '@/img/rfc-logo.svg'
import spdLogo from '@/img/spd-logo.svg'
import spdWordmark from '@/img/spd-logo-wordmark.svg'
import spdWordmarkInk from '@/img/spd-logo-wordmark-ink.svg'
import spdBrandLogo from '@/img/spd-logo-bg.svg'

const config = computed(() => configService.getAll())

export const LogoPath = computed(() => {
  const client = config.value.CLIENT
  if (client === 'metro-spb') return metroLogo
  if (client === 'rkn') return rknLogo
  if (client === 'rfc') return rfcLogo
  if (client === 'spd') return spdLogo
  return defaultLogo
})

/** Landing wordmark: white type on the navy SPD header. */
export const SpdHeaderLogo = spdWordmark

/** Same wordmark with navy type, for the light sign-in card. */
export const SpdSigninLogo = spdWordmarkInk

/** Wide wordmark for login / home placeholder (SPD). */
export const BrandLogoPath = computed(() => {
  if (config.value.CLIENT === 'spd') return spdBrandLogo
  return null
})

export default LogoPath
